const travelNetURL = 'https://www.thesilverlining.com/personal-insurance/roadside-assistance-from-travelnet';
const policyDocumentsText =
  'Log in and navigate to “Policy Documents” in the left navigation menu. From there, select the coverage period and document you’d like to view, and click “View Document.” You can then view, print, or download the document.';
const policyChangesText =
  'To make any policy changes, such as adding/deleting a vehicle or changing an address, please contact your agent.';
const userSupportText =
  'For assistance, please contact Technical Support at 1-800-236-5004 Monday through Friday during business hours of 8:00 AM to 4:30 PM CST. You may also contact us at';
const customerSupportEmail = 'CustomerSupport@wbmi.com';
const billingEmail = 'billing@wbmi.com';
const claimsText =
  'If you have a loss, West Bend provides several easy options for reporting a claim, 24 hours a day, 7 days a week.';
const accordionTitle1 = 'How can I contact roadside assistance?';
const accordionTitle2 = 'How can I view my policy documents?';
const accordionTitle3 = 'How can I make policy changes?';
const travelNetText = 'If you have TravelNet®, call 877-922-5246 and press 1.';
const noLogin = 'No log in needed';
const payBill = 'Pay bill';
const contactUs = 'Contact us';
const frequentQ = 'Frequently asked questions';

export {
  travelNetURL,
  policyDocumentsText,
  policyChangesText,
  userSupportText,
  customerSupportEmail,
  billingEmail,
  claimsText,
  accordionTitle1,
  accordionTitle2,
  accordionTitle3,
  travelNetText,
  noLogin,
  payBill,
  contactUs,
  frequentQ,
};
